// Where an uploaded file goes in a rich-text field.
//
// TipTap leaves a just-inserted file tile node-selected, and inserting over
// a selection replaces it — so three files attached in a row (one pick of
// several, a drop, or three clicks) left only the last in the field, though
// all three reached Attachments. A selected tile is kept: the next file goes
// after it. Any other selection is replaced, as typing over it would.
export function attachmentInsertRange(selection) {
  if (selection?.node) return { from: selection.to, to: selection.to };
  return { from: selection.from, to: selection.to };
}
